import { some } from "lodash";
import { useActivityPageContext } from "PFApp/activities/show/activity_page_context";
import { useGrowl } from "PFApp/use_growl";
import { Button } from "PFComponents/button";
import { useShortlistFill } from "PFCore/hooks/queries/shortlists/use_shortlist_actions";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import css from "../shortlist_actions.modules.scss";

type FillButtonProps = {
  shortlistId: number;
};

export const FillButton = ({ shortlistId }: FillButtonProps): JSX.Element => {
  const { t } = useTranslation(["translation", "activities"]);

  const { vacancies } = useActivityPageContext();

  const { mutate: fillShortlist } = useShortlistFill();

  const growl = useGrowl();

  const handleClick = useCallback(() => {
    const hasOpenVacancy = some(vacancies.entries, (vacancy) => vacancy.state !== "closed");

    if (hasOpenVacancy) {
      fillShortlist(shortlistId);
    } else {
      growl({
        message: t("activities:show.parts.fillRoleWarning"),
        kind: "alert"
      });
    }
  }, [vacancies.entries, shortlistId]);
  return <Button text={t("translation:fill")} className={css.button} kind="primary" onClick={handleClick} />;
};
